import { makeStyles } from '@material-ui/core/styles';


export default makeStyles((theme) => ({
    root:{
        display:'flex',
        backgroundColor:'#dedede',
        marginTop:'15%',
        marginBottom:'1%',
        textAlign:'center',
        [theme.breakpoints.down("xs")]: {
            marginTop:'30%',
            height:'60px',
            fontSize:'100%',
        },
    },
    search:{
        borderRadius:'0',
        [theme.breakpoints.down("xs")]: {
            height:'40px'
        },
    },
    searchButton:{
        
        [theme.breakpoints.down("xs")]: {
            height:'20px'
        },
    },
    price:{
        width:'15%',
        padding:'0.5%',
        [theme.breakpoints.down("xs")]: {
            width:'20%',
            
        },
    },
    city:{
        width:'12%',
        padding:'0.5%',
        
    },
    category:{
        width:'12%',
        padding:'0.5%',
        [theme.breakpoints.down("xs")]: {
            paddingLeft:'10%'
        },
    },
    category2:{
        [theme.breakpoints.down("xs")]: {
            marginLeft:'5px',
            height:'20px'
        },
    },
    pagination: {
        borderRadius: 4,
        marginTop: '1rem',
        padding: '16px 2%',
    },
    filter:{
        width:'45%',
        
        [theme.breakpoints.down("xs")]: {
            width:'40%'
        },
    },
    dialog:{
        width:'300px',
        marginTop:'35px'
    },
    checkbox:{
        paddingLeft:'6%',
        paddingTop:'2%',
        [theme.breakpoints.down("xs")]: {
            display:'none'
        },
    }
}))